import { computed } from 'vue'
import { useMenuStore } from '@/stores/MenuStore'

export type { MenuItem } from '@/types/menu'

export function useMenuData() {
  const store = useMenuStore()
  store.fetchMenu()
  return { menu: computed(() => store.menu) }
}
